import { CSSProperties } from 'react';

export const PreventUserSelectSansCursor: CSSProperties = {
  userSelect: 'none',
  'WebkitUserSelect': 'none',
};

export const PreventUserSelect: CSSProperties = {
  ...PreventUserSelectSansCursor,
  cursor: 'default',
};
